"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterQuery = void 0;
function getFilterKey(params) {
    return `${params.property}:${params.groupId || ''}`;
}
class FilterQuery {
    constructor(initialValue) {
        this.value = {};
        initialValue.forEach((filter) => {
            this.value[getFilterKey(filter)] = Object.freeze(filter);
        });
    }
    static fromArray(filters) {
        return new this(filters);
    }
    static fromGroups(filterGroups) {
        const items = Object.keys(filterGroups).reduce((acc, groupId) => {
            const filters = filterGroups[groupId];
            return [...acc, ...filters.map((filter) => (Object.assign(Object.assign({}, filter), { groupId })))];
        }, []);
        return new this(items);
    }
    fromArray(filters) {
        return new this.constructor(filters);
    }
    mapFilter(filterIndex, map) {
        const index = typeof filterIndex === 'string' ? { property: filterIndex, groupId: '' } : filterIndex;
        let nextValue = [];
        if (!this.value[getFilterKey(index)]) {
            nextValue = Array.from(Object.values(this.value));
            const nextFilterValue = typeof map === 'function' ? map({ property: index.property, value: '' }) : map;
            if (nextFilterValue !== null) {
                nextValue.push(Object.assign(Object.assign(Object.assign({}, nextFilterValue), { property: index.property }), (index.groupId ? { groupId: index.groupId } : {})));
            }
            return new this.constructor(nextValue);
        }
        Object.values(this.value).forEach((value) => {
            const matchGroup = (value.groupId || '') === index.groupId;
            if (value.property === index.property && matchGroup) {
                const nextFilterValue = typeof map === 'function' ? map(value) : map;
                if (nextFilterValue !== null) {
                    nextValue.push(Object.assign(Object.assign(Object.assign({}, nextFilterValue), { property: index.property }), (index.groupId ? { groupId: index.groupId } : {})));
                }
                return;
            }
            nextValue.push(value);
        });
        return new this.constructor(nextValue);
    }
    getFilterValue(filterIndex) {
        var _a;
        return ((_a = this.getFilter(filterIndex)) === null || _a === void 0 ? void 0 : _a.value) || null;
    }
    getFilter(filterIndex) {
        const index = typeof filterIndex === 'string' ? { property: filterIndex, groupId: '' } : filterIndex;
        return this.value[getFilterKey(index)] || null;
    }
    getFilterList() {
        return Object.values(this.value);
    }
    getFilterLisByGroupId(groupId) {
        return Object.values(this.value).filter((v) => v.groupId === groupId);
    }
    toString() {
        return JSON.stringify(this.getFilterList());
    }
}
exports.FilterQuery = FilterQuery;
//# sourceMappingURL=FilterQuery.js.map